export default "\nfloat fmap(in float v) {\n    return log(v);\n}\n";